import TwoFactorContainer from "../../Componant/FormLayout/TwoFactor";

const TwoFactor = () => {
  return (
    <div className="page-body">
      <TwoFactorContainer />
    </div>
  );
};

export default TwoFactor;
